import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { DPR_API } from "../../services/apiCalls/dprApiCalls";
import { toast } from "react-toastify";

export default function RiskRegisterForm({ project, subId, onSubmit }) {
  const location = useLocation();
  const pro = project || location.state;

  const [workPackages, setWorkPackages] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [workPackageId, setWorkPackageId] = useState("");
  const [taskId, setTaskId] = useState();
  const [formData, setFormData] = useState({
    projectName: pro?.Project_Name,
    productCategory: pro?.Product_Category,
    location: pro?.Location,
    // activityTask: "",
    riskDueDate: "",
    riskDescription: "",
    impactLevel: "",
    probability: "",
    riskScore: "",
    mitigationStrategy: "",
    riskStatus: "",
    assignedPersonEmail: "",
    turnIntoIssue: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    if (onSubmit) onSubmit();

    e.preventDefault(); // Prevents the default form submission behavior
    const state = JSON.parse(localStorage.getItem("state"));

    let obj = {
      ProjectID: pro?.project_id,
      TaskID: taskId,
      ProjectName: pro?.Project_Name,
      ProductCategory: pro?.Product_Category,
      Activity_task: formData?.activityTask,
      Location: pro?.Location,
      RiskDueDate: formData?.riskDueDate,
      RiskDescription: formData?.riskDescription,
      ImpactDescription: formData?.ImpactDescription,
      ImpactLevel: formData?.impactLevel,
      Probability: formData?.probability,
      RiskScore: formData?.riskScore,
      MitigationStrategy: formData?.mitigationStrategy,
      RiskStatus: formData?.riskStatus,
      AssignedPersonEmail: formData?.assignedPersonEmail,
      UserID: state.user.user_id,
    };
    const saveRisk = await DPR_API.SaveRiskDetails(obj);
    if (saveRisk && saveRisk?.status === 201) {
      toast.success(saveRisk?.Message, { autoClose: 2000 });
    } else {
      toast.error(saveRisk?.Message, { autoClose: 2000 });
    }
  };

  useEffect(() => {
    const impactLevel = parseFloat(formData.impactLevel) || 0;
    const probability = parseFloat(formData.probability) || 0;
    const riskScore = impactLevel * probability;
    setFormData((prevData) => ({
      ...prevData,
      riskScore: riskScore.toFixed(2),
    }));
  }, [formData.impactLevel, formData.probability]);

  const fetchWorkPackage = async () => {
    let state = JSON.parse(localStorage.getItem("state"));

    let obj = {
      EmailID: state.user.Email,
      ProjectGUID: pro?.ProjectGUID,
    };
    const dpr = await DPR_API.GetProjectWorkPackage(obj);
    setWorkPackages(dpr.WorkPackagelList || []);
  };
  const fetchTasks = async (workPackageId) => {
    const dprResponse = await DPR_API.getDprDetails(workPackageId);
    if (dprResponse && dprResponse?.subtasks?.length > 0) {
      setTasks(dprResponse?.subtasks);
    } else {
      setTasks([]);
    }
  };
  useEffect(() => {
    fetchWorkPackage();
  }, []);
  useEffect(() => {
    if (!subId) {
      fetchTasks(workPackageId);
    } else {
      setTaskId(subId);
    }
  }, [workPackageId]);
  return (
    // <form onSubmit={handleSubmit}>
    <>
      <div className="row">
        <div className="col-6">
          <label className="label-custom">Project Name</label>
          <input
            disabled
            type="text"
            name="projectName"
            value={formData.projectName}
            className="form-control shadow-none"
            onChange={handleChange}
          />
        </div>
        <div className="col-6">
          <label className="label-custom">Product Category</label>
          <input
            disabled
            type="text"
            name="productCategory"
            value={formData.productCategory}
            className="form-control shadow-none"
            onChange={handleChange}
          />
        </div>
      </div>
      {!subId && (
        <>
          <div className="row mt-2">
            <div className="col-6">
              <label className="label-custom">WorkPackage</label>
              <select
                name="workpackage"
                id="workpackage"
                onChange={(e) => {
                  setWorkPackageId(e.target.value);
                  setTaskId("");
                }}
                className="filter-label"
                style={{
                  width: "100%",
                  height: 31,
                  border: "1px solid #e6e3e3",
                  borderRadius: 4,
                }}
              >
                <option value="">select workpackge</option>
                {workPackages.map((val) => (
                  <option value={val?.WorkPackageID}>
                    {val?.WorkPackageName}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-6">
              <label className="label-custom">Task</label>
              <select
                name="task"
                id="task"
                className="filter-label"
                onChange={(e) => setTaskId(e.target.value)}
                style={{
                  width: "100%",
                  height: 31,
                  border: "1px solid #e6e3e3",
                  borderRadius: 4,
                }}
              >
                <option value="">select task</option>
                {tasks.map((val) => (
                  <option value={val?.DPRID}>{val?.Subtask}</option>
                ))}
              </select>
            </div>
          </div>
        </>
      )}

      <div className="row mt-2">
        <div className="col-6">
          <label className="label-custom">Location</label>
          <input
            disabled
            type="text"
            name="location"
            value={formData.location}
            className="form-control shadow-none"
            onChange={handleChange}
          />
        </div>
        {/* <div className="col-6">
          <label className="label-custom">Activity/Task</label>
          <input
            type="text"
            name="activityTask"
            value={formData.activityTask}
            className="form-control shadow-none"
            onChange={handleChange}
          />
        </div> */}
        <div className="col-6">
          <label className="label-custom">Assigned Person Email</label>
          <input
            type="text"
            name="assignedPersonEmail"
            value={formData.assignedPersonEmail}
            className="form-control shadow-none"
            onChange={handleChange}
          />
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-6">
          <label className="label-custom">Risk Due Date</label>
          <input
            type="date"
            name="riskDueDate"
            value={formData.riskDueDate}
            className="form-control shadow-none"
            onChange={handleChange}
          />
        </div>
        <div className="col-6">
          <label className="label-custom">Risk Description</label>
          <textarea
            name="riskDescription"
            value={formData.riskDescription}
            className="form-control shadow-none"
            onChange={handleChange}
          />
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-6">
          <label className="label-custom">Impact Level</label>
          <input
            type="text"
            name="impactLevel"
            value={formData.impactLevel}
            className="form-control shadow-none"
            onChange={handleChange}
          />
        </div>
        <div className="col-6">
          <label className="label-custom">Probability</label>
          <input
            type="text"
            name="probability"
            value={formData.probability}
            className="form-control shadow-none"
            onChange={handleChange}
          />
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-6">
          <label className="label-custom">Risk Score</label>
          <input
            type="text"
            name="riskScore"
            value={formData.riskScore}
            className="form-control shadow-none"
            onChange={handleChange}
            disabled
          />
        </div>
        <div className="col-6">
          <label className="label-custom">Mitigation Strategy</label>
          <textarea
            name="mitigationStrategy"
            value={formData.mitigationStrategy}
            className="form-control shadow-none"
            onChange={handleChange}
          />
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-6">
          <label className="label-custom">Risk Status</label>
          <select
            name="riskStatus"
            value={formData.riskStatus}
            className="filter-label"
            style={{
              width: "100%",
              height: 31,
              border: "1px solid #e6e3e3",
              borderRadius: 4,
            }}
            onChange={handleChange}
          >
            <option value="">Select status</option>
            <option value="Open">Open</option>
            <option value="Close">Close</option>
          </select>
        </div>
      </div>
      {/* <div className="row mt-2">
        <div className="col-12">
          <label className="label-custom">Turn into issue</label>
          <input
            type="text"
            name="turnIntoIssue"
            value={formData.turnIntoIssue}
            className="form-control shadow-none"
            onChange={handleChange}
          />
        </div>
      </div> */}
      <div className="row mt-4 pb-3">
        <div className="d-flex justify-content-center">
          <div className="m-2">
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleSubmit}
            >
              Submit
            </button>
          </div>
          <div className="m-2">
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => {
                if (onSubmit) onSubmit();
                setFormData({});
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
